import React from 'react'
import Loader from 'react-loader-spinner'

class CustomLoader extends React.Component {
    
    render() {
        if(this.props.isLoading == true){
        return (
            <div className="flexcc loader-container">
                <Loader
                    type={this.props.type ?? "TailSpin"}
                    color={this.props.color ?? "#000"}
                    height={this.props.height ?? 20}
                    width={this.props.width ?? 20}
                    className={this.props?.className}
                />
            </div>
        )
        }else{
            return <></>
        }
    }
}
export default CustomLoader